import { useCallback } from "react";
import { viewOverrideId } from "./viewOverrideId";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { PAGE_CONFIGS, PageType } from "@/constants/PageType";
import { useRemoveAddIn } from "@/hooks/addins/useRemoveAddIn";
import { ViewOverride } from "@/models/DiagnosticView";

export function useResetViewOverride(pageType: PageType) {
  const addInId = PAGE_CONFIGS[pageType].addInId;
  const { me } = useGeotabClient();
  const removeAddIn = useRemoveAddIn<ViewOverride>(addInId, "id");

  const resetOverride = useCallback(
    async (viewId: string) => {
      if (!me?.id) return false;
      return removeAddIn.mutateAsync({ delSearch: viewOverrideId(me.id, viewId) });
    },
    [removeAddIn, me?.id],
  );

  return { resetOverride, isPending: removeAddIn.isPending };
}
